(function () {
  'use strict';

  var STEP_GOAL = 'goal';
  var STEP_DURATION = 'duration';
  var STEP_PAY = 'pay';

  function recommendedTerm(goal, duration) {
    if (goal === 'prevent') {
      if (duration === 'as_long') return '24';
      if (duration === 'year') return '12';
      if (duration === 'open') return '6';
      return '';
    }
    if (goal === 'pregnant') return '6';
    if (goal === 'cycle') return '12';
    return '';
  }

  function setText(el, value) {
    if (!el) return;
    el.textContent = value == null ? '' : String(value);
  }

  function initV8Logic() {
    var root = document.querySelector('.right-column-v8');
    if (!root) return;
    if (root.getAttribute('data-ml353-bound') === '1') return;
    root.setAttribute('data-ml353-bound', '1');

    var titleEl = root.querySelector('.v8-quiz-title');
    var options = root.querySelectorAll('.v8-option');
    var copyNodes = root.querySelectorAll('.v8-step-copy [data-step]');
    var segs = root.querySelectorAll('.v8-progress-seg');
    var backBtn = root.querySelector('.v8-back');
    var nextBtn = root.querySelector('.v8-next');
    var startOverBtns = root.querySelectorAll('.v8-start-over');
    var cards = root.querySelectorAll('.v8-plan-card');
    var ctaBtn = document.getElementById('v8-add-to-cart');
    var toggle = document.getElementById('v8-billingToggle');
    var toggleLabel = document.getElementById('v8-toggle-label');
    var pillsWrap = root.querySelector('.v8-pills');
    var readerTitleEl = root.querySelector('.v8-answers-reader-title');
    var readerSubEl = root.querySelector('.v8-answers-reader-sub');
    var sectionEl = root.closest('.shopify-section') || document;
    var banners = sectionEl.querySelectorAll('.v8-promo-banner, .ml-promo-banner');
    var billingWrapper = root.querySelector('.billing-cards-wrapper');

    var copyByStep = {};
    copyNodes.forEach(function (node) {
      copyByStep[node.getAttribute('data-step')] = {
        title: node.getAttribute('data-title') || '',
        progress: parseInt(node.getAttribute('data-progress') || '1', 10)
      };
    });

    var state = {
      step: STEP_GOAL,
      goal: '',
      duration: '',
      pay: '',
      history: [STEP_GOAL]
    };

    function currentValue() {
      if (state.step === STEP_GOAL) return state.goal;
      if (state.step === STEP_DURATION) return state.duration;
      if (state.step === STEP_PAY) return state.pay;
      return '';
    }

    function setCurrentValue(value) {
      if (state.step === STEP_GOAL) state.goal = value;
      else if (state.step === STEP_DURATION) state.duration = value;
      else if (state.step === STEP_PAY) state.pay = value;
    }

    function isUpfront() {
      return toggle ? toggle.checked : true;
    }

    function optionLabel(step, value) {
      var match = '';
      options.forEach(function (opt) {
        if (opt.getAttribute('data-step') === step && opt.getAttribute('data-value') === value) {
          match = opt.getAttribute('data-label') || '';
        }
      });
      return match;
    }

    function renderPills() {
      if (!pillsWrap) return;
      var items = [];
      if (state.goal) items.push(optionLabel(STEP_GOAL, state.goal));
      if (state.goal === 'prevent' && state.duration) items.push(optionLabel(STEP_DURATION, state.duration));
      if (state.pay) items.push(optionLabel(STEP_PAY, state.pay));
      pillsWrap.innerHTML = items
        .filter(Boolean)
        .map(function (label) {
          return '<span class="v8-pill">' + label.replace(/</g, '&lt;') + '</span>';
        })
        .join('');
    }

    function firstVisibleCard(term) {
      var list = root.querySelectorAll('.v8-plan-card[data-term="' + term + '"]');
      for (var i = 0; i < list.length; i++) {
        if (window.getComputedStyle(list[i]).display !== 'none') return list[i];
      }
      return list[0] || null;
    }

    function isFreeReaderCombo() {
      return state.goal === 'prevent' && state.duration === 'as_long' && state.pay === 'once';
    }

    function updateReaderCard() {
      if (!readerTitleEl || !readerSubEl) return;
      if (isFreeReaderCombo()) {
        setText(readerTitleEl, readerTitleEl.getAttribute('data-free-title') || 'inne Reader · €99');
        setText(readerSubEl, readerSubEl.getAttribute('data-free-sub') || 'one-time payment, then nothing more');
        return;
      }
      setText(
        readerTitleEl,
        readerTitleEl.getAttribute('data-default-title') || readerTitleEl.textContent
      );
      setText(readerSubEl, readerSubEl.getAttribute('data-default-sub') || readerSubEl.textContent);
    }

    function updateBanners() {
      var show = false;
      var isMobile = window.innerWidth <= 767;
      banners.forEach(function (banner) {
        if (
          banner.id === 'ml-promo-promo_banner_UgkVfQ' ||
          banner.id === 'ml-promo-promo_banner_e4w3Di'
        ) {
          banner.style.setProperty('display', 'none', 'important');
          return;
        }
        var isRight =
          banner.classList.contains('v8-promo-banner--right') ||
          banner.classList.contains('ml-promo-banner--right');
        var visible = show && ((isMobile && isRight) || (!isMobile && !isRight));
        banner.style.setProperty('display', visible ? 'flex' : 'none', 'important');
      });
    }

    function scrollToMatchedPlan(card) {
      if (!card) return;
      window.setTimeout(function () {
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 80);
    }

    function updatePricing() {
      var upfront = isUpfront();

      if (toggleLabel) {
        toggleLabel.textContent = upfront
          ? toggleLabel.getAttribute('data-upfront') || 'Billed upfront'
          : toggleLabel.getAttribute('data-monthly') || 'Pay monthly';
      }

      cards.forEach(function (card) {
        var titleEl = card.querySelector('.dynamic-v8-title');
        var priceEl = card.querySelector('.dynamic-v8-price');
        var readerTextEl = card.querySelector('.dynamic-v8-reader-text');
        var stripTextEl = card.querySelector('.dynamic-v8-strip-text');
        var stripPriceEl = card.querySelector('.dynamic-v8-strip-price');
        var readerPriceEl = card.querySelector('.dynamic-v8-reader-price');
        var cardBadge = card.querySelector('.v8-card-badge');

        if (cardBadge) cardBadge.style.display = upfront ? 'block' : 'none';
        if (titleEl) titleEl.innerHTML = upfront ? titleEl.getAttribute('data-upfront') : titleEl.getAttribute('data-monthly');
        if (priceEl) priceEl.innerHTML = upfront ? priceEl.getAttribute('data-upfront') : priceEl.getAttribute('data-monthly');
        if (readerTextEl)
          readerTextEl.innerHTML = upfront
            ? readerTextEl.getAttribute('data-upfront')
            : readerTextEl.getAttribute('data-monthly');
        if (stripTextEl)
          stripTextEl.innerHTML = upfront
            ? stripTextEl.getAttribute('data-upfront')
            : stripTextEl.getAttribute('data-monthly');
        if (stripPriceEl)
          stripPriceEl.innerHTML = upfront
            ? stripPriceEl.getAttribute('data-upfront')
            : stripPriceEl.getAttribute('data-monthly');

        if (readerPriceEl) {
          var rPrice = upfront
            ? readerPriceEl.getAttribute('data-upfront-price')
            : readerPriceEl.getAttribute('data-monthly-price');
          var rDiscount = upfront
            ? readerPriceEl.getAttribute('data-upfront-discount')
            : readerPriceEl.getAttribute('data-monthly-discount');

          if (rDiscount && rDiscount.trim() !== '') {
            readerPriceEl.innerHTML =
              "<s style='opacity: 0.6; font-weight: normal; margin-right: 5px;'>" +
              rPrice +
              "</s> <span style='color:#F2853C; font-weight:700;'>" +
              rDiscount +
              '</span>';
          } else {
            readerPriceEl.innerHTML = rPrice || '';
          }
        }

        card.querySelectorAll('.v8-card-selected [data-upfront][data-monthly]').forEach(function (el) {
          el.innerHTML = upfront ? el.getAttribute('data-upfront') : el.getAttribute('data-monthly');
        });
      });

      updateBanners();

      var activeCard = root.querySelector('.v8-plan-card.is-active') || cards[0];
      if (!activeCard || !ctaBtn) return;
      var radio = activeCard.querySelector('.v8-hidden-radio');
      if (!radio) return;
      var url = upfront ? radio.getAttribute('data-url-upfront') : radio.getAttribute('data-url-monthly');
      ctaBtn.href = url || '#';
    }

    function selectCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-active');
        var radio = c.querySelector('.v8-hidden-radio');
        if (radio) radio.checked = false;
      });
      if (!card) return;
      card.classList.add('is-active');
      var radio = card.querySelector('.v8-hidden-radio');
      if (radio) radio.checked = true;
      updatePricing();
    }

    function applyRecommendation() {
      var term = recommendedTerm(state.goal, state.duration);
      cards.forEach(function (c) {
        c.classList.remove('is-match');
      });
      if (!term) {
        updatePricing();
        return;
      }
      var card = firstVisibleCard(term) || cards[0];
      if (card) card.classList.add('is-match');
      selectCard(card);
      renderPills();
      updateReaderCard();
    }

    function setBillingFromQuiz(upfront) {
      if (toggle && toggle.checked !== upfront) {
        toggle.checked = upfront;
      }
      if (billingWrapper) {
        billingWrapper.querySelectorAll('.billing-card').forEach(function (card) {
          card.classList.remove('is-active');
        });
        var radio = billingWrapper.querySelector(
          'input.hidden-radio[value="' + (upfront ? 'upfront' : 'monthly') + '"]'
        );
        if (radio) {
          radio.checked = true;
          var card = radio.closest('.billing-card');
          if (card) card.classList.add('is-active');
        }
      }
      updatePricing();
    }

    function showStep(step) {
      state.step = step;
      var copy = copyByStep[step] || { title: '', progress: 1 };
      setText(titleEl, copy.title);

      var progress = copy.progress || 1;
      segs.forEach(function (seg, idx) {
        seg.classList.toggle('is-on', idx < progress);
      });

      options.forEach(function (opt) {
        var visible = opt.getAttribute('data-step') === step;
        opt.classList.toggle('is-visible', visible);
        opt.classList.toggle('is-selected', visible && opt.getAttribute('data-value') === currentValue());
      });

      if (backBtn) backBtn.classList.toggle('is-hidden', state.history.length < 2);
      if (nextBtn) nextBtn.disabled = !currentValue();
    }

    function goResult() {
      applyRecommendation();
      renderPills();
      updateReaderCard();
      root.classList.add('is-result');
      scrollToMatchedPlan(root.querySelector('.v8-plan-card.is-match') || root.querySelector('.v8-plan-card.is-active'));
    }

    function nextStepFrom(step) {
      if (step === STEP_GOAL) return state.goal === 'prevent' ? STEP_DURATION : STEP_PAY;
      if (step === STEP_DURATION) return STEP_PAY;
      return null;
    }

    function onNext() {
      if (!currentValue()) return;
      if (state.step === STEP_PAY) {
        goResult();
        return;
      }
      var next = nextStepFrom(state.step);
      if (!next) return;
      state.history.push(next);
      showStep(next);
      applyRecommendation();
    }

    function onBack() {
      if (state.history.length < 2) return;
      root.classList.remove('is-result');
      state.history.pop();
      showStep(state.history[state.history.length - 1]);
    }

    function startOver() {
      state.goal = '';
      state.duration = '';
      state.pay = '';
      state.history = [STEP_GOAL];
      cards.forEach(function (card) {
        card.classList.remove('is-active', 'is-match');
        var radio = card.querySelector('.v8-hidden-radio');
        if (radio) radio.checked = false;
      });
      var defaultCard = root.querySelector('.v8-plan-card[data-default="true"]') || cards[0];
      selectCard(defaultCard);
      if (pillsWrap) pillsWrap.innerHTML = '';
      root.classList.remove('is-result');
      setBillingFromQuiz(true);
      updateReaderCard();
      showStep(STEP_GOAL);
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (opt.getAttribute('data-step') !== state.step) return;
        var value = opt.getAttribute('data-value') || '';
        setCurrentValue(value);

        if (state.step === STEP_PAY) {
          setBillingFromQuiz(value !== 'monthly');
        }

        options.forEach(function (other) {
          if (other.getAttribute('data-step') === state.step) {
            other.classList.toggle('is-selected', other === opt);
          }
        });

        applyRecommendation();
        onNext();
      });
    });

    if (nextBtn) nextBtn.addEventListener('click', onNext);
    if (backBtn) backBtn.addEventListener('click', onBack);
    startOverBtns.forEach(function (btn) {
      btn.addEventListener('click', startOver);
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectCard(card);
      });
    });

    if (toggle) {
      toggle.addEventListener('change', updatePricing);
    }

    if (billingWrapper) {
      billingWrapper.addEventListener('change', updatePricing);
    }

    window.addEventListener('resize', updatePricing);
    window.addEventListener('pageshow', function () {
      updatePricing();
    });

    showStep(STEP_GOAL);
    updatePricing();
  }

  window.initV8Logic = initV8Logic;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initV8Logic);
  } else {
    initV8Logic();
  }
})();
